import { useCallback, useEffect, useState } from "react";
import { addresses } from "../../../shared/data";

interface IUseLegalEntity {
    adress: string;
}

export const useLegalEntity = (): IUseLegalEntity => {
    const [adress, setAdress] = useState<string>("");

    function getRandomArbitrary(min: number, max: number) {
        return Math.floor(Math.random() * (max - min) + min);
    }

    const getEntity = useCallback(() => {
        const target = getRandomArbitrary(0, addresses.length);

        setAdress(addresses[target]);
    }, []);

    useEffect(() => {
        getEntity();
    }, [getEntity]);

    return {
        adress,
    }
}